module.exports = __webpack_public_path__ + "assets/media/3.82f0acf0.wav";